import { isElectron } from './isElectron';

export const getEnvValue = (varName: string): string | undefined => {
  if (isElectron()) {
    return (window.electron.env as any)[varName];
  }

  if (typeof process.env !== 'undefined' && process.env[varName]) {
    return process.env[varName];
  }

  return undefined;
};
